import FingerprintJS from "@fingerprintjs/fingerprintjs";

// Identifies this browser to a focus-group pipeline link (PipelineJoin.tsx).
// The device token is the real key: random, kept in localStorage, so a
// returning participant lands back on their own survey. The fingerprint is
// only a fallback the backend uses when the token was lost (cleared storage,
// private window) — identical company devices can share one.

const DEVICE_TOKEN_KEY = "survey_device_token";

// A v4 UUID, built by hand since this project's TypeScript predates crypto.randomUUID.
function randomUuid(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function getDeviceToken(): string {
  try {
    const existing = localStorage.getItem(DEVICE_TOKEN_KEY);
    if (existing) return existing;
    const token = randomUuid();
    localStorage.setItem(DEVICE_TOKEN_KEY, token);
    return token;
  } catch {
    // Storage blocked: this visit still works, it just won't be recognised next time.
    return randomUuid();
  }
}

export async function getDeviceFingerprint(): Promise<string | null> {
  try {
    const agent = await FingerprintJS.load();
    const { visitorId } = await agent.get();
    return visitorId || null;
  } catch {
    return null;
  }
}
